import ModalComponent from '../../components/ModalComponent';

interface Props {
  pageTitle: string
  open: boolean
  handleClose: () => void
  handleSave: () => void
  loadingSave?: boolean
}

const Index = (props: Props) => {
  const {
    open, pageTitle, handleClose, handleSave, loadingSave,
  } = props;

  return (
    <ModalComponent
      title="Duplicate page"
      confirmButtonText="Duplicate"
      onConfirm={handleSave}
      show={open}
      closeModal={handleClose}
      centered
      animation={false}
      disabled={loadingSave}
      loading={loadingSave}
    >
      <p className="mb-0">
        Are you sure you want to duplicate &quot;
        {pageTitle}
        &quot;?
      </p>
    </ModalComponent>
  );
};

export default Index;
